import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'

//---Importing Components---
import Avatar from './Avatar'


// ------Imports to be modified ------------
import EditPencilIcon from './EditPencilIcon'
import EditPencilIconFilled from './EditPencilIconFilled'
// -------------------------------------------

const IndivudualProfile = ({ avatar = null, name = null, isThisProfileSelected = null, isEditEnabled = null, editFunction = null, isKid = false }) => {
    //--Props--
    // avatar - SVG, name - <string> - Profile Name, status - null/selected - To show the selected background color
    // isEdit - false/true - To show or hide the pencil (edit) icon

    // const [editIconHover, setEditIconHover] = useState(false)
    const { profileManagementThemes = {}, } = useSelector(store => store.profileManagement)

    const [theme, setTheme] = useState(null)

    // --Setting Profile List Theme---
    useEffect(() => {
        setTheme(profileManagementThemes.themeProfileList)
    }, [profileManagementThemes])

    const stopPropogating = (e) => {
        e.stopPropagation();
        editFunction()
    }


    return (
        <IndivudualProfileStyled isThisProfileSelected={isThisProfileSelected} theme={theme}>
            <div className="indivudual-profile-wrapper">
                <div className="indivudual-profile-wrapper__avatar">
                    {<Avatar height='60px' image={avatar} status={isThisProfileSelected ? 'selected' : ''} showBorder={isThisProfileSelected} />}
                </div>
                <div className="indivudual-profile__kid_label">
                    <div className="indivudual-profile-wrapper__name">{name}</div>
                    {isKid && <div className="indivudual-profile__kid_label__kid_label">Kids</div>}
                </div>
                {isEditEnabled && <div className="indivudual-profile-wrapper__edit-icon" onClick={(e) => stopPropogating(e)} >
                    <EditPencilIconFilled className="profile-icon---hover" color='#ffd200' height='21px' /> 
                    <EditPencilIcon className="profile-icon---normal" color='#ffd200' height='21px' />
                </div>}
            </div>
        </IndivudualProfileStyled>
    )
}

const IndivudualProfileStyled = styled.div`
    .indivudual-profile-wrapper{
        padding: 30px 41px;
        display: flex;
        flex-direction: row;
        align-items: center;

        background-color: ${({ isThisProfileSelected, theme: { compositeStyle } }) => isThisProfileSelected ? compositeStyle && compositeStyle.selectorStyle && compositeStyle.selectorStyle.selected && compositeStyle.selectorStyle.selected.background : ''};

        :hover{
            background-color: ${({ theme: { compositeStyle } }) => compositeStyle && compositeStyle.selectorStyle && compositeStyle.selectorStyle.focussed && compositeStyle.selectorStyle.focussed.background};
        }

        .indivudual-profile-wrapper__avatar{
            
        }//indivudual-profile-wrapper__avatar

       
            
        .indivudual-profile__kid_label{
            display: flex;
            flex-direction: column;
            margin-left: 10px;

            .indivudual-profile-wrapper__name{
                color: ${({ theme: { compositeStyle } }) => compositeStyle && compositeStyle.selectorStyle && compositeStyle.selectorStyle.normal && compositeStyle.selectorStyle.normal.text};
                :hover{
                    color: ${({ theme: { compositeStyle } }) => compositeStyle && compositeStyle.selectorStyle && compositeStyle.selectorStyle.focussed && compositeStyle.selectorStyle.focussed.text};
                }
            }

            .indivudual-profile__kid_label__kid_label{
                font-size: 16px;
                font-weight: 300;
                color: ${({ theme: { compositeStyle } }) => compositeStyle && compositeStyle.selectorStyle && compositeStyle.selectorStyle.normal && compositeStyle.selectorStyle.normal.text};
                

                :hover{
                    color: ${({ theme: { compositeStyle } }) => compositeStyle && compositeStyle.selectorStyle && compositeStyle.selectorStyle.focussed && compositeStyle.selectorStyle.focussed.text};
                }
            }//indivudual-profile__kid_label__kid_label

        }//indivudual-profile__kid_label
        .indivudual-profile-wrapper__edit-icon{
            margin-left: auto;
        }//indivudual-profile-wrapper__edit-icon


    }//indivudual-profile-wrapper
`


export default IndivudualProfile